<template>
  <div class="app-container activity-list">
    <div class="activity-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="activity-list-filter-value" v-model.trim="search.name" @keyup.enter.native="searchChange" placeholder="名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <!-- <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select 
              class="activity-list-filter-value"
              ref="activityTypeSelect" 
              v-model="search.type" 
              @keyup.enter.native="searchChange" 
              @keydown.enter.native="$refs.activityTypeSelect.visible = false" 
              placeholder="培训类型" 
              clearable 
              size="small">
              <el-option
                v-for="(item, index) in activityTypes"
                :key="index"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-col> -->
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select 
             class="activity-list-filter-value"
              ref="activityStatusSelect" 
              v-model="search.status" 
              @keyup.enter.native="searchChange" 
              @keydown.enter.native="$refs.activityStatusSelect.visible = false" 
              placeholder="状态" 
              clearable 
              size="small">
              <el-option
                v-for="(item, index) in statusTypeOptions"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="activity-list-filter-value" v-model.trim="search.createBy" @keyup.enter.native="searchChange" placeholder="创建人" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="activity-list-filter-reset" size="small" @click="searchReset">清除条件</el-button>
            <el-button class="activity-list-filter-search" size="small" @click="searchChange">立即筛选</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container class="activity-list-container">
      <avue-crud
        ref="crud"
        :option="tableOption"
        :data="tableData"
        :page="page"
        :table-loading="tableLoading"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        @sort-change="handleSortChange">

         <template slot="name" slot-scope="scope">
           <div class="name">
             <div class="cover-image" v-if="scope.row.listPageImage" v-viewer>
              <img :src="scope.row.listPageImage | ossImageProcess">
            </div>
            <a href="javascript:void(0);" @click="handleView(scope.row,scope.index)"
                class="activity-list-container-button">
                {{scope.row.name}}
            </a>
           </div>
        </template>

        <template slot="activityUrl" slot-scope="scope">
          <el-button type="text" @click="previewImg(scope.row.activityUrl)">
            <div>modules/activity/{{scope.row.id}}</div>
          </el-button>
        </template>

        <template slot="miniProgramCodeUrl" slot-scope="scope">
          <el-button type="text" @click="previewMiniProgramQrcode(scope.row.id, scope.row.name, scope.row.nameEn)">
            点击查看
          </el-button>
        </template>

        <template slot="menuLeft">
          <el-button type="primary" v-if="permissions.activity_add" icon="el-icon-plus" size="small" @click="handleAddActivity">新增</el-button>
        </template>

        <template slot-scope="scope" slot="menu">
          <el-row>
            <el-button size="mini"
            type="text"
            icon="el-icon-view"
            v-if="permissions.activity_view"
            @click="handleView(scope.row,scope.index)">查看</el-button>
            
            <el-button size="mini"
              type="text"
              icon="el-icon-mobile-phone"
              @click="openActivityQrCodeDialog(scope.row.id)">预览
            </el-button>

            <el-button size="mini"
              type="text"
              icon="el-icon-edit"
              v-if="permissions.activity_edit"
              @click="handleEdit(scope.row,scope.index)">编辑
            </el-button>

            <el-button size="mini"
              type="text"
              icon="el-icon-upload2"
              v-if="permissions.activity_publish && scope.row.status == activityStatus.CREATED"
              @click="openPublishDialog(scope.row.status, scope.row.id)">上架
            </el-button>

            <!-- <el-button size="mini"
              type="text"
              icon="el-icon-view"
              v-if="scope.row.activityUrl"
              @click="openQrCodeDialog(scope.row.activityUrl)">预览
            </el-button> -->

            <el-button size="mini"
              type="text"
              icon="el-icon-delete"
              v-if="permissions.activity_del && scope.row.status == activityStatus.CREATED"
              @click="handleDelete(scope.row.id)">删除
            </el-button>

            <el-button size="mini"
              type="text"
              icon="el-icon-download"
              v-if="permissions.activity_publish && scope.row.status != activityStatus.CREATED"
              @click="showPullOffDailog(scope.row.id)">下架
            </el-button>
          </el-row>
        </template>
      </avue-crud>
    </basic-container>
    <el-dialog
      title="请使用微信扫描预览二维码"
      :visible.sync="activityQrCodeDialogVisible"
      width="40%"
      center>
      <span slot="footer" class="dialog-footer">
       <el-row>
        <div class="qr-code1">
        <div class="qr-code-content">
          <div class="qr-code-img">
            <vue-qr :text="activityZhQrCodeValue" size="150"></vue-qr>
          </div>
          <p class="qr-code-url">中文预览</p>
        </div>
        <div class="qr-code-content">
          <div class="qr-code-img">
            <vue-qr :text="activityEnQrCodeValue" size="150"></vue-qr>
          </div>
          <p class="qr-code-url">英文预览</p>
        </div>
        </div>
        <p class="qr-code-url">链接地址</p>
        <p class="qr-code-url">中文：{{activityZhQrCodeValue}}</p>
        <p class="qr-code-url">英文：{{activityEnQrCodeValue}}</p>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="培训详情"
      :visible.sync="imgDialogVisible"
      fullscreen
      custom-class="preview-img-dialog">
      <div @click="imgDialogVisible = false">
        <vue-qr :text="previewImgUrl" :size="qrCodeSize"></vue-qr>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="miniprogramQrcodeDialogVisible"
      fullscreen
      custom-class="preview-img-dialog"
      @closed="previewMiniProgramQrcodeUrl=''">
      <div @click="miniprogramQrcodeDialogVisible = false" class="qr-code">
        <img :src="previewMiniProgramQrcodeUrl" class="qr-code-img" width="70%"/>
        <p class="qr-code-name">{{previewActivityName}}</p>
        <p class="qr-code-name">{{previewActivityNameEn}}</p>
      </div>
    </el-dialog>

    <el-dialog
      title="上架培训"
      :visible.sync="activityPublishDialogVisible"
       width="35%">
       <template>
         <el-row class="dialog-body-row">您确定要上架该培训吗？</el-row>
         <el-row class="dialog-body-row">
           <el-checkbox v-model="isActivityPublishNotice">发送短信</el-checkbox>
         </el-row>
       </template>
       <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="activityPublishDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handlePublishActivity()">确定</el-button>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="下架培训"
      :visible.sync="activityPullOffDialogVisible"
       width="35%">
       <template>
         <el-row class="dialog-body-row">您确定要下架该培训吗？</el-row>
         <el-row class="dialog-body-row">
          <el-input type="textarea" placeholder="请输入下架该培训的原因" :rows="3" v-model="messageToPullOffActivity" :maxlength="500"></el-input>
         </el-row>
         <el-row class="dialog-body-row">
           <el-checkbox v-model="isActivityPullOffNoticeInvitedUser">发短信给受邀用户</el-checkbox>
           <el-checkbox v-model="isActivityPullOffNoticeEnrolledUser">发短信给已报名用户</el-checkbox>
         </el-row>
       </template>
       <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="closePullOffDialogVisible()">取消</el-button>
          <el-button type="primary" @click="handlePullOffActivity()">确定</el-button>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="二维码"
      :visible.sync="qrCodeDialogVisible"
      width="35%"
      center>
      <template>
        <el-row>
          <div class="ju-modal-content">
            <div :class="{'option-select': qrCodeSize == 1000}" @click="changeQrCodeSize(1000)" class="size-options">
              <div class="size-content">
                <div class="size-types">大尺寸</div>
                <div class="size-value">1000x1000像素</div>
              </div>
            </div>
            <div :class="{'option-select': qrCodeSize == 500}" @click="changeQrCodeSize(500)" class="size-options">
              <div class="size-content">
                <div class="size-types">中等尺寸</div>
                <div class="size-value">500x500像素</div>
              </div>
            </div>
            <div :class="{'option-select': qrCodeSize == 300}" @click="changeQrCodeSize(300)" class="size-options">
              <div class="size-content">
                <div class="size-types">小尺寸</div>
                <div class="size-value">300x300像素</div>
              </div>
            </div>
          </div>
        </el-row>
      </template>
      
      <span slot="footer" class="dialog-footer">
       <el-row>
          <div>
            <vue-qr :text="qrCodeValue" size="300"></vue-qr>
          </div>
          <div id="activity-qr-code">
            <vue-qr :text="qrCodeValue" :size="qrCodeSize"></vue-qr>
          </div>
          <el-button @click="closeQrCodeDialog()">关闭</el-button>
          <el-button type="primary" @click="downloadQrCode()">下载</el-button>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="选择培训数目"
      :visible.sync="activityModeVisible"
      width="464px">
      <template>
        <el-row class="dialog-title">请选择需要新增的培训类型</el-row>
        <el-row class="dialog-description">一旦选择并创建后，无法修改培训类型</el-row>
      </template>
      <div class="activity-mode">
        <button :class="['activity-mode-btn', {'activity-mode-select': isSingleSelected}]" @click="selectSingleMode">
          <img src="~@/static/images/activity/activity-single-mode.png" class="activity-mode-icon"/>
          <p class="title">单项课程</p>
        </button>
        <button :class="['activity-mode-btn', {'activity-mode-select': isMultipleSelected}]" @click="selectMultipleMode">
          <img src="~@/static/images/activity/activity-multiple-mode.png" class="activity-mode-icon"/>
          <p class="title">系列课程</p>
        </button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="activityModeVisible = false">取消</el-button>
          <el-button type="primary" @click="handlePushAddActivity">确定</el-button>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import vueQr from 'vue-qr';
import { listTableOption, statusTypeOptions, activityStatus } from '@/const/crud/app/activity';
import Api from '@/api/app/activity';
import { mapGetters } from "vuex";
import { formatDate } from '@/util/date';

export default {
  data() {
    return {
      messageToPullOffActivity: '',
      statusTypeOptions,
      activityStatus,
      search: {
        current: 1,
        size: 10,
        sortField: "",
        sortPolicy: "",
        name: "",
        type: undefined,
        status: '',
        createBy: '',
      },
      tableData:[],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableLoading: false,
      tableOption: listTableOption,
      activityTypes: [],
      publishActivityId: undefined,
      publishActivityStatus: '',
      activityPublishDialogVisible: false,
      isActivityPublishNotice: false,
      activityPullOffDialogVisible: false,
      isActivityPullOffNoticeInvitedUser: false,
      isActivityPullOffNoticeEnrolledUser: false,
      qrCodeDialogVisible: false,
      qrCodeValue: '',
      qrCodeSize: 300,
      previewImgUrl: '',
      imgDialogVisible: false,
      previewMiniProgramQrcodeUrl: '',
      previewActivityName: '',
      previewActivityNameEn: '',
      miniprogramQrcodeDialogVisible: false,
      activityModeVisible: false,
      isSingleSelected: false,
      isMultipleSelected: false,
      multipleProjectsMode: '',
      activityQrCodeDialogVisible: false,
      activityZhQrCodeValue: '',
      activityEnQrCodeValue: '',
    };
  },
  created() {
    // this.getTypes();
    this.getList();
  },
  activated () {
    // this.getTypes();
    this.getList();
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    openActivityQrCodeDialog(id) {
      this.activityQrCodeDialogVisible = true;
      this.activityZhQrCodeValue = process.env.VUE_APP_BASIC_PAGE_PATH + `/activity-preview/${id}?lang=zh`;
      this.activityEnQrCodeValue = process.env.VUE_APP_BASIC_PAGE_PATH + `/activity-preview/${id}?lang=en`;
    },
    initPage() {
      this.page.currentPage = 1;
      this.page.pageSize = this.search.size;
      this.search.current = 1;
      this.search.sortField = "";
      this.search.sortPolicy = "";
    },
    async getTypes() {
      const response = await this.requestWrapper(Api.getAllActivityTypes);
      if (response.code === 0) {
        this.activityTypes = response.data;
      } else {
        this.$message.error(response.msg);
      }
    },
    getList() {
        let params = {
          current: this.search.current,
          size: this.search.size,
        }
        if (this.search.name != "" && this.search.name.trim() != "") {
          params.name = this.search.name;
        }
        if (this.search.type) {
          params.type = this.search.type;
        }
        if (this.search.status) {
          params.status = this.search.status;
        }
        if (this.search.createBy != "" && this.search.createBy.trim() != "") {
          params.createBy = this.search.createBy;
        }
        if (this.search.sortField != "" && this.search.sortField.trim() != "") {
          params.sortField = this.search.sortField;
        } else {
        params.sortField = "inserted_time";
        }
      if (this.search.sortPolicy != "" && this.search.sortPolicy.trim() != "") {
        params.sortPolicy = this.search.sortPolicy;
      } else {
        params.sortPolicy = "desc";
      }

      this.tableLoading = true;
      Api.fetchMcActivityList(params).then(response => {
        if (response.data.code === 0) {
          this.tableData = this.formatData(response.data.data.records);
          this.page.total = response.data.data.total;
          this.tableLoading = false;
        } else {
          this.$message.error(response.data.msg);
        }
      })
    },
    formatData(records) {
      let tempTableDatas=[];
      if (records && records.length > 0) {
        records.forEach((record, index) => {
          let tempTableData ={};
          tempTableData.id = record.id;
          tempTableData.status = record.status;
          tempTableData.activityUrl = record.activityUrl;
          tempTableData.image = record.image;
          tempTableData.listPageImage = record.listPageImage;
          tempTableData.name = record.name;
          tempTableData.nameEn = record.nameEn;
          // const type = this.activityTypes.find(item => item.id == record.type);
          // tempTableData.type = type ? type.name : '';
          const format = 'YYYY-mm-dd HH:MM';
          tempTableData.startTime = formatDate(format, new Date(record.startTime));
          tempTableData.endTime = formatDate(format, new Date(record.endTime));
          tempTableData.enrollmentCount = record.enrollmentCount ? record.enrollmentCount : 0;
          tempTableData.maxEnrollmentCount = record.maxEnrollmentCount ? record.maxEnrollmentCount : 0;
          tempTableData.createBy = record.insertedByName ? record.insertedByName: '--';
          tempTableData.createTime = record.insertedTime;
          tempTableDatas.push(tempTableData);
        });
      }
      return tempTableDatas;
    },
    searchChange() {
      this.initPage();
      this.getList();
    },
    searchReset() {
      this.search.name = "";
      this.search.status = undefined;
      this.search.type = undefined;
      this.search.createBy = '';
      this.searchChange();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.search.current = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.search.size = val;
      this.getList();
    },
    handleSortChange(val) {
      if (val.prop == "createTime") {
        this.search.sortField = "inserted_time";
      } else {
        this.search.sortField = "";
      }
      // 检查排序方式
      if (val.order == 'ascending') {
        this.search.sortPolicy = "asc";
      } else if (val.order == 'descending') {
        this.search.sortPolicy = "desc";
      } else {
        this.search.sortPolicy = "";
      }
      this.getList();
    },
    handleView(row, index) {
      if (row.id){
        this.$router.push({
          path: `/app/activity/detail/${row.id}`,
        });
      } else {
        this.$message({
          showClose: true,
          message: '该培训不存在',
          type: 'warning',
        });
      }
    },
    handleAddActivity() {
      this.isMultipleSelected = false;
      this.isSingleSelected = false;
      this.multipleProjectsMode = '';
      this.activityModeVisible = true;
    },
    selectSingleMode() {
      this.isMultipleSelected = false;
      this.isSingleSelected = true;
      this.multipleProjectsMode = false;
    },
    selectMultipleMode() {
      this.isMultipleSelected = true;
      this.isSingleSelected = false;
      this.multipleProjectsMode = true;
    },
    handlePushAddActivity() {
      if (this.multipleProjectsMode === '') {
        this.$message.warning('请选择需要新增的培训类型');
      } else {
        this.activityModeVisible = false;
        this.$router.push({ path: '/app/activity/add', query: {multipleProjectsMode: this.multipleProjectsMode} });
      }
    },
    handleEdit(row, index) {
      this.$router.push({ path: `/app/activity/edit/${row.id}` });
    },
    handleDelete(activityId) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        Api.removeMcActivity(activityId).then((response) => {
          if (response.data.code === 0) {
            this.getList();
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success',
              duration: 2000,
            });
          } else {
            this.$message.error(response.data.msg);
          }
        });
      });
    },
    openPublishDialog(status, activityId) {
      this.publishActivityStatus = status;
      this.publishActivityId = activityId;
      this.activityPublishDialogVisible = true;
    },
    handlePublishActivity() {
      const msgRef = this.$message({
        type: 'warning',
        message: '正在上架培训 ...',
        duration: 0,
      });
      this.activityPublishDialogVisible = false;
      Api.publishActivity(this.publishActivityId, { isSendMessage: this.isActivityPublishNotice }).then(response => {
        if (response.data.code === 0) {
          this.$message.success("成功上架培训");
          this.getList();
        } else {
          this.$message.error(response.msg);
        }
      }).finally(() => {
        msgRef.close();
      });
    },
    showPullOffDailog(activityId) {
      this.publishActivityId = activityId;
      this.activityPullOffDialogVisible = true;
    },
    closePullOffDialogVisible() {
      this.messageToPullOffActivity = '';
      this.activityPullOffDialogVisible = false;
    },
    handlePullOffActivity() {
      if (this.messageToPullOffActivity === '' || this.messageToPullOffActivity.trim() === '') {
        this.$message.error('下架原因不能为空');
        return;
      }
       const msgRef = this.$message({
        type: 'warning',
        message: '正在下架培训 ...',
        duration: 0,
      });
      Api.pullDownActivity(
        this.publishActivityId, 
        { 
          isSendMessageToInvitedUser: this.isActivityPullOffNoticeInvitedUser,
          isSendMessageToEnrolledUser: this.isActivityPullOffNoticeEnrolledUser,
          reason: this.messageToPullOffActivity
        }
      ).then(response => {
        if (response.data.code === 0) {
          this.$message.success("成功下架培训");
          this.messageToPullOffActivity = '';
          this.getList();
        } else {
          this.$message.error(response.msg);
        }
      }).finally(() => {
        msgRef.close();
      });
      this.activityPullOffDialogVisible = false;
    },
    openQrCodeDialog(url) {
      this.qrCodeDialogVisible = true;
      this.qrCodeValue = url;
    },
    copyLink(row) {
      const url = process.env.VUE_APP_BASIC_PAGE_PATH + `/modules/activity/${row.id}`
      this.$copyText(url).then(
        res => {
          this.$message({
            showClose: true,
            type: 'success',
            message: '已成功复制'
          })
        },
        err => {
          this.$message({
            showClose: true,
            type: 'error',
            message: '失败'
          })
        }
		  )
    },
    closeQrCodeDialog() {
      this.qrCodeDialogVisible = false;
      this.qrCodeValue = '';
    },
    changeQrCodeSize(size) {
      this.qrCodeSize = size;
    },
    downloadQrCode() {
      const imgUrl = document.getElementById('activity-qr-code').firstElementChild.src;
      if (window.navigator.msSaveOrOpenBlob) {
        let bstr = atob(imgUrl.split(",")[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let blob = new Blob([u8arr]);
        window.navigator.msSaveOrOpenBlob(blob, "qrcode" + "." + "png");
      } else {
        let a = document.createElement("a");
        a.href = imgUrl;
        a.setAttribute("download", "qrcode");
        a.click();
      }
    },
    previewImg(url) {
      this.previewImgUrl = url;
      this.imgDialogVisible = true;
    },
    previewMiniProgramQrcode(activityId, name, nameEn) {
      const messageRef = this.$message({
        message: "获取小程序二维码中...",
        type: "warning",
        duration: 0,
      });
      setTimeout(() => {
        Api.getActivityMiniProgramCode(activityId).then((response) =>{
          messageRef.close();
          this.previewMiniProgramQrcodeUrl = response.data.data;
          this.miniprogramQrcodeDialogVisible = true;
          this.previewActivityName = name;
          this.previewActivityNameEn = nameEn;
        });
      }, 1000);
    }
  }
};
</script>

<style>
.cancelButtonClass {
  color: #606266 !important;
  background-color: white !important;
  border: 1px solid #dcdfe6 !important;
}
.cancelButtonClass:hover {
  color: #606266 !important;
  background-color: #dcdfe6 !important;
  border: 1px solid #dcdfe6 !important;
}
</style>
<style lang="scss" scoped>
.activity-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-value {
      width: calc(100% - 12px) !important;
    }
    &-reset {
      margin-left: 10px;
    }
    &-search {
      margin-left: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }

 .activity-status {
    width: 50px;
    height: 34px;
    border: none;
    background-position: top center;
    background-repeat: no-repeat;
    &.published {
      background-image: url("~@/static/images/activity/update_icn_24x32.png");
    }
    &.pending {
      background-image: url("~@/static/images/activity/pending_list_icn.png");
    }
    &.approved {
      background-image: url("~@/static/images/activity/approved_list_icn.png");
    }
    &.reject {
      background-image: url("~@/static/images/activity/approval_failed_list_icn.png");
    }
    &.updated {
      background-image: url('~@/static/images/activity/updated_list_icn.png');
    }
  }
}

.dialog-body-row {
  line-height: 36px;
}

.name {
  display: flex;
  align-items: center;
  .cover-image {
    display: flex;
    width: fit-content;
    margin-right: 12px;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      max-width: 100%;
    }
  }
}
#activity-qr-code {
  display: none;
}
.ju-modal-content {
  display: flex;
	justify-content: center;
}
.size-options {
  width: 120px;
  height: 80px;
  border-radius: 2px;
  color: #71849c;
  display: inline-block;
  background-color: #d7e3f0;
  text-align: center;
  cursor: pointer;

  &:nth-child(1) {
    margin-right: 20px;
  }

  &:nth-child(2) {
    margin-right: 20px;
  }
  .size-content {
    margin-top: 14px;
    .size-types {
      font-size: 18px;
    }
    .size-value {
      font-size: 14px;
    }
  }
}
.option-select {
  background-color: #8aaed9;
  color: 'white';
}
/deep/ .el-dialog.preview-img-dialog{
  background: rgba(0, 0, 0, 0.5);
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 40px;
      right: 40px;
      .el-dialog__close {
        font-size: 20px;
        color: #fff;
        font-weight: bold;
        border: 2px solid #fff;
        border-radius: 50%;
        padding: 5px;
      }
    }
  }
  .el-dialog__body {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0;
    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
}
.qr-code {
  height: 84vh;
  width: 84vh;
  background-color: white;
  &-img {
    margin-top: 30px;
    user-select: none;
    pointer-events: none;
  }
  &-name {
    font-size: 20px;
    margin-top: 10px;
    font-weight: 600;
  }
}
.dialog-title {
  font-size: 14px;
  font-weight: 400;
  color: #3B3B3B;
  line-height: 21px;
}
.dialog-description {
  font-size: 14px;
  font-weight: 400;
  color: #7D7D7D;
  line-height: 21px;
}
.activity-mode {
  padding: 9px 16px;
  display: inline-block;
  text-align: center;
  border-bottom: 1px solid #DDDDDD;
  &-btn {
    margin: 14px;
    height: 166px;
    width: 166px;
    border-radius: 2px;
    border: 1px solid #DDDDDD;
    background-color: white;
    text-align: center;
    .title {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      color: #3B3B3B;
      line-height: 21px;
    }
  }
  &-btn:hover {
    background-color: rgba(232,244,251,0.4);
    border: 1px solid #1994D7;
  }
  &-select {
    background-color: rgba(232,244,251,0.4);
    border: 1px solid #1994D7;
  }
  &-icon {
    width: 80px;
    height: 80px;
  }
}
.qr-code1 {
  display: flex;
  .qr-code-content {
    flex: 1;
    .qr-code-img {
      width: 150px;
      height: 150px;
      margin: 0 auto;
      margin-top: -40px;
      padding: 12px;
      border: 1px solid rgb(230, 230, 230);
      border-radius: 8px;
      background-color: rgb(245, 245, 245);
    }
  }
}
.qr-code-url {
  color: #606266;
}
</style>
